import React, { useState } from 'react';

const LeftPanel = ({ categories, onSelectCategory }) => {
  const [isJewelsOpen, setIsJewelsOpen] = useState(false);

  // UPDATED: Added "Modern Chain" and "Covering Chain" to the sub-menu list
  const jewelCategories = [
    "Traditional Jewels", "Kundans", "Kemps", "Chokers", 
    "Chains", "Modern Chain", "Covering Chain",
    "Rings", "Bangles", "Earrings", "American Diamond"
  ];

  // This part automatically separates the remaining categories
  const otherCategories = categories.filter(cat => !jewelCategories.includes(cat));

  return (
    <aside className="left-panel">
      <h3>Categories</h3>
      <ul>
        <li onClick={() => onSelectCategory(null)} className="category-item">All Products</li>
        
        {/* Collapsible Jewels Menu */}
        <li onClick={() => setIsJewelsOpen(!isJewelsOpen)} className="category-item parent">
          Jewels <span className={`arrow ${isJewelsOpen ? 'open' : ''}`}>▼</span>
        </li>
        {isJewelsOpen && (
          <ul className="submenu">
            {jewelCategories.map(category => (
              // This logic now correctly finds and displays your new categories if they exist in the master list
              categories.includes(category) && (
                <li key={category} onClick={() => onSelectCategory(category)} className="category-item sub-item">
                  {category}
                </li>
              )
            ))}
          </ul>
        )}

        {/* Other Categories */}
        {otherCategories.map(category => (
          <li key={category} onClick={() => onSelectCategory(category)} className="category-item">
            {category}
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default LeftPanel;